import React from 'react';
import { getStoredUser } from '../api';
import MultiSelectFilter from './MultiSelectFilter';

/**
 * Agentes que el filtro deja fuera al abrir (6-oct-2026, pedido de Samuel: «que
 * nada cambie, sólo no veamos a Tanya»). El nombre es el de Genesys, exacto.
 *
 * Viaja como `agent_excluir` y NO como la lista de todos los demás en `agent`,
 * aunque en el desplegable se vea así. La lista cambiaría más de lo pedido:
 * sacaría las llamadas sin agente (abandonos, IVR) de cada total, y en
 * Cumplimiento → Evolución la referencia dejaría de ser «Equipo» para volverse
 * «Promedio de los demás»… que serían sólo los excluidos.
 *
 * Sólo para admin: un agente ve sus llamadas y nada más, y la exclusión, en la
 * barra de Tanya, la dejaría sin las suyas.
 *
 * Vive aquí y no dentro de `AnalyticsFilterBar` porque hay pantallas con su
 * propio filtro de agente (Reporte de ventas) — con una copia, una de las dos
 * dejaría de ocultarla en cuanto alguien cambiara la otra.
 */
const AGENTES_FUERA_POR_OMISION = ['Tanya Mejia Garcia'];

export const agentesFueraPorOmision = () => (
  getStoredUser()?.role === 'admin' ? AGENTES_FUERA_POR_OMISION : []
);

/** Los params del API para una selección. Sólo una de las dos formas viaja. */
export const paramsDeAgentes = (elegidos, excluidos) => {
  if (elegidos.length) return { agent: elegidos };
  if (excluidos.length) return { agent_excluir: excluidos };
  return {};
};

/**
 * El desplegable de agentes. La selección se guarda de dos formas, y sólo una
 * vale a la vez: `elegidos` (los marcados) o `excluidos` (todos menos éstos).
 */
export default function FiltroDeAgentes({
  opciones, elegidos, setElegidos, excluidos, setExcluidos,
}) {
  // En modo exclusión se ven marcados todos menos los excluidos: un agente que
  // aparezca después (alta nueva) entra marcado, que es lo que «todos menos
  // Tanya» quiere decir. Sin elegidos NI excluidos no se marca nada: es «sin
  // filtro», igual que en los demás desplegables. Antes caía en «todos menos
  // nadie» y «Deseleccionar todos» dejaba la lista entera marcada.
  const enExclusion = !elegidos.length && excluidos.length > 0;
  const marcados = elegidos.length
    ? elegidos
    : enExclusion ? opciones.filter((a) => !excluidos.includes(a)) : [];

  const cambiar = (siguiente) => {
    // «Deseleccionar todos», o se venía eligiendo agentes: lista de elegidos.
    if (!enExclusion || !siguiente.length) {
      setElegidos(siguiente); setExcluidos([]);
      return;
    }
    const fuera = opciones.filter((a) => !siguiente.includes(a));
    // Con más desmarcados que marcados ya no es «todos menos unos»: es una
    // selección de agentes, y como tal se filtra (sin llamadas sin agente).
    if (fuera.length > siguiente.length) {
      setElegidos(siguiente); setExcluidos([]);
    } else {
      setExcluidos(fuera);
    }
  };

  return (
    <MultiSelectFilter
      label="Todos los agentes" options={opciones} value={marcados} onChange={cambiar}
      resumen={enExclusion
        ? `Todos menos ${excluidos.length === 1 ? excluidos[0].split(' ')[0] : excluidos.length}`
        : undefined}
      titulo={enExclusion ? `Todos los agentes menos ${excluidos.join(', ')}` : undefined}
      textoLimpiar="Deseleccionar todos"
    />
  );
}
